import React from "react";

let FormHeader = ({text}) => <div className='form-header'>
    {text}
</div>

export default FormHeader